import {Component, OnInit} from '@angular/core';
import {NavController} from '@ionic/angular';
import {RequesterService} from '../../services/requester.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AnalyticsService} from '../../services/analytics.service';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../services/user.service';


@Component({
    selector: 'app-login',
    templateUrl: './static-pages.page.html',
    styleUrls: ['./static-pages.page.scss']
})
export class StaticPagesPage implements OnInit {

    public title = '';
    public text = '';

    constructor(
        private analytics: AnalyticsService,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private router: Router,
        public userService: UserService,
        private navController: NavController,
        private requesterService: RequesterService
    ) {
    }

    ngOnInit() {
        const alias = this.activatedRoute.snapshot.paramMap.get('alias');
        switch (alias) {
            case 'serviceUnavailable':
                this.title = 'Service temporarily unavailable';
                this.text = 'Service temporarily unavailable';
                break;
            default:
                this.router.navigate(['/home']);
                break;
        }

    }

    ionViewDidEnter() {
        this.analytics.trackEvent('exception', {
            description: 'Service temporarily unavailable',
            fatal: true
        });
    }

    getPing() {
        return this.requesterService.ping()
            .then(data => {
                if ((data.body as any).result === 'auth') {
                    return 'auth';
                } else {
                    return 'no-auth';
                }
            })
            .catch(e => {
                return 'no-connect';

            });
    }

    tryAgain() {
        this.getPing()
            .then(res => {
                if (res === 'auth') {
                    this.navController.back();
                } else if (res === 'no-auth') {
                    this.router.navigate(['/login']);
                }
            });
    }

}
